<app-header-page>
    <app-component-button-header-back href="/account/assignments/all">
        {{ 'HEADERS.ASSIGNMENT' | translate }}
    </app-component-button-header-back>
</app-header-page>

<div *ngIf="assignment"
     class="row min-h-100"
     style="background: white;"
>
    <div class="col-8 p-3">
        <h2>Поручение:
            <app-component-input-inline
                    (emitSave)="editAssignment('title', $event)"
                    [editByPen]="true"
                    [value]="assignment.title"
            ></app-component-input-inline>
        </h2>
        <div>
            <div class="super__tabs">
                <div (click)="tab = 'global'"
                     [class.active]="tab === 'global'"
                     class="super__tabs tab">
                    <span>Поручение</span>
                </div>
                <div (click)="tab = 'tasks'"
                     [class.active]="tab === 'tasks'"
                     class="super__tabs tab">
                    <span>Задачи</span>
                </div>
            </div>

            <div class="tab__content">
                <ng-container *ngIf="tab === 'global'">
                    <ng-container *ngTemplateOutlet="globalAssignment"></ng-container>
                </ng-container>
                <ng-container *ngIf="tab === 'tasks'">
                    <ng-container *ngTemplateOutlet="assignmentTasks"></ng-container>
                </ng-container>
            </div>

            <ng-template #globalAssignment>
                <app-component-ckeditor
                        (emitFinish)="editAssignment('content', $event[1])"
                        [inputData]="assignment.content"
                ></app-component-ckeditor>

                <div class="mt-3">
                    <app-task-detail-comments [canCreateComments]="true"
                                              [commentsType]="'assignment'"
                                              [key]="assignmentId"
                    ></app-task-detail-comments>
                </div>
            </ng-template>

            <ng-template #assignmentTasks>
                <div class="p-3 m-2">
                    <app-component-tasks-table
                            [colons]="colons"
                            [isMini]="true"
                            [isSubtasks]="true"
                            [tasks]="assignment.tasks"
                    ></app-component-tasks-table>
                </div>
            </ng-template>
        </div>
    </div>
    <div class="col-4 p-3">
        <p class="m-0">Создан: {{ helpers.formatDate(assignment.created_at) }}</p>
        <p class="m-0">Обновлен: {{ helpers.formatDate(assignment.updated_at) }}</p>
        <p class="m-0">
            <span *ngIf="assignment.author"
                  [class.blocked_user]="assignment.author.project_setting.observation_type === 'blocked'"
                  [class.inactive_user]="!assignment.author.is_active"
            >
                Автор:
                <img *ngIf="assignment.author.project_setting.is_project_admin"
                     alt="#"
                     ngbTooltip="{{ 'USER_PROFILE.ROLE.ADMIN' | translate }}"
                     src="../../../../assets/images/admin.svg">
                <span (click)="helpers.openProfileByGuid(assignment.author.guid)"
                      class="user_profile"
                >
                    {{ helpers.shortFullName(assignment.author) }}
                </span>
            </span>
        </p>

        <p class="position-relative m-0">
            {{ 'TASKS.DETAIL.TEXT.DUE_TIME' | translate }}:
            <span (click)="calendar.click()"
                  style="cursor: pointer;"
            >
                <ng-container *ngIf="assignment.due_date">
                    {{ assignment.due_date | date:'dd.MM.yyyy' }}
                </ng-container>
                <ng-container *ngIf="!assignment.due_date">
                    {{ 'TASKS.DETAIL.TEXT.EMPTY' | translate }}
                </ng-container>
            </span>
            <app-component-date-time-picker #calendar
                                            (pickedDate)="editAssignment('due_date', $event)"
                                            [hiddenCalendar]="true"
                                            [showTime]="false"
                                            [stringify]="true"
            ></app-component-date-time-picker>
        </p>
        <div>
            <span>{{ 'TASKS.DETAIL.TEXT.DURATION' | translate }}:</span>
            <span aria-expanded="false"
                  data-bs-toggle="dropdown"
                  style="cursor: pointer;"
            >
                <ng-container *ngIf="assignment.due_time">
                    {{ assignment.due_time }}
                </ng-container>
                <ng-container *ngIf="!assignment.due_time">
                    <small>{{ 'TASKS.DETAIL.TEXT.EMPTY' | translate }}</small>
                </ng-container>
            </span>
            <ul class="dropdown-menu">
                <li>
                    <div class="input-group mb-3">
                        <input #time
                               aria-describedby="button-addon2"
                               class="form-control"
                               id="duration"
                               ngbTooltip="Время в формате: чч:мм:сс"
                               placeholder="Время в формате: чч:мм:сс"
                               type="text">
                        <button (click)="editAssignment('due_time', time.value)"
                                class="btn btn-outline-secondary"
                                id="button-addon2"
                                type="button">
                            {{ 'TASKS.BUTTONS.SET' | translate }}
                        </button>
                    </div>
                </li>
                <li><a (click)="editAssignment('due_time', '00:15:00')"
                       class="dropdown-item">15 {{ 'TASKS.DETAIL.TEXT.TIME.MINS' | translate }}</a>
                </li>
                <li><a (click)="editAssignment('due_time', '00:30:00')"
                       class="dropdown-item">30 {{ 'TASKS.DETAIL.TEXT.TIME.MINS' | translate }}</a>
                </li>
                <li><a (click)="editAssignment('due_time', '01:00:00')"
                       class="dropdown-item">1 {{ 'TASKS.DETAIL.TEXT.TIME.HOUR' | translate }}</a>
                </li>
                <li><a (click)="editAssignment('due_time', '03:00:00')"
                       class="dropdown-item">3 {{ 'TASKS.DETAIL.TEXT.TIME.HOURS' | translate }}</a>
                </li>
                <li><a (click)="editAssignment('due_time', '06:00:00')"
                       class="dropdown-item">6 {{ 'TASKS.DETAIL.TEXT.TIME.HOURS' | translate }}</a>
                </li>
                <li><a (click)="editAssignment('due_time', '12:00:00')"
                       class="dropdown-item">12 {{ 'TASKS.DETAIL.TEXT.TIME.HOURS' | translate }}</a>
                </li>
                <li><a (click)="editAssignment('due_time', '23:59:59')"
                       class="dropdown-item">1 {{ 'TASKS.DETAIL.TEXT.TIME.DAY' | translate }}</a>
                </li>
            </ul>
        </div>
        <p class="m-0">
            <app-component-button-more
                    (answer)="changeAssignmentStatus($event)"
                    [bold]="true"
                    [hidden]="true"
                    [variables]="[
                                    {key: 'new', icon: 'icon-up-16px', title: 'Новое' | translate, color: '#3CD33C'},
                                    {key: 'in_progress', icon: 'icon-up', title: 'В процессе' | translate, color: '#d9c72b'},
                                    {key: 'executed', icon: 'icon-up-1', title: 'Исполнено' | translate, color: '#E62E49'},
                                    {key: 'archived', icon: 'icon-up-1', title: 'Архив' | translate, color: '#ee94a1'}
                                ]"
                    position="left"
            >
                <p>
                    Статус:
                    <span style="cursor: pointer;"> {{ statuses[assignment.status] }} </span>
                </p>
            </app-component-button-more>
        </p>
        <p>
            <button (click)="openCreateTaskModal(createTaskView)"
                    class="btn btn-success"
            >
                <span>Создать задачу</span>
            </button>
            <button (click)="deleteAssignment()"
                    [ngbTooltip]="'Удалить поручение'"
                    class="btn btn-danger ml-2"
            >
                <i class="bi bi-trash"></i>
            </button>
        </p>


        <div *ngIf="assignment.executors.usersModels && assignment.executors.usersModels.length"
             class="mt-2">
            <strong>Исполнители:</strong>
            <a *ngFor="let user of assignment.executors.usersModels"
               class="list-group-item list-group-item-action"
               style="display: flex; justify-content: space-between; max-width: 200px; margin-top: 4px;">
                <span [class.blocked_user]="user.project_setting.observation_type === 'blocked'"
                      [class.inactive_user]="!user.is_active"
                >
                    <img *ngIf="user.project_setting.is_project_admin"
                         alt="#"
                         ngbTooltip="{{ 'USER_PROFILE.ROLE.ADMIN' | translate }}"
                         src="../../../../assets/images/admin.svg">
                    {{ helpers.shortFullName(user, true) }}
                </span>
                <i (click)="delExecutor(user)"
                   class="icon-delete text-danger ms-auto p-2"
                   data-action="delExecutor"
                   style="z-index: 100; cursor: pointer; padding: unset !important; margin-left: 15px !important;">
                </i>
            </a>
        </div>
        <div *ngIf="assignment.executors.department.length"
             class="mt-2">
            <strong>Департаменты:</strong>
            <a *ngFor="let departmentItem of assignment.executors.department"
               class="list-group-item list-group-item-action">
                <span>
                    {{ departmentItem.name }}
                </span>
            </a>
        </div>
        <div *ngIf="assignment.executors.division.length"
             class="mt-2">
            <strong>Отделы:</strong>
            <a *ngFor="let divisionItem of assignment.executors.division"
               class="list-group-item list-group-item-action">
                <span>
                    {{ divisionItem.name }}
                </span>
            </a>
        </div>
        <button (click)="openAddExecutorModal(addMemberModal)"
                class="btn btn-primary mt-2"
        >
            <span>Добавить</span>
        </button>
    </div>
</div>

<ng-template #addMemberModal
             let-modal
>
    <app-button-modal-close [modal]="modal"></app-button-modal-close>
    <div class="modal-body">
        <div class="super__tabs">
            <div (click)="addExecutorTab = 'user'"
                 [class.active]="addExecutorTab === 'user'"
                 class="super__tabs tab">
                <span>Пользователь</span>
            </div>
            <div (click)="addExecutorTab = 'department'"
                 [class.active]="addExecutorTab === 'department'"
                 class="super__tabs tab">
                <span>Департамент</span>
            </div>
            <div (click)="addExecutorTab = 'division'"
                 [class.active]="addExecutorTab === 'division'"
                 class="super__tabs tab">
                <span>Отдел</span>
            </div>
        </div>

        <div class="tab__content">
            <ng-container *ngIf="addExecutorTab === 'user'">
                <ng-container *ngTemplateOutlet="addMember"></ng-container>
            </ng-container>
            <ng-container *ngIf="addExecutorTab === 'department'">
                <ng-container *ngTemplateOutlet="addDepartment"></ng-container>
            </ng-container>
            <ng-container *ngIf="addExecutorTab === 'division'">
                <ng-container *ngTemplateOutlet="addDivision"></ng-container>
            </ng-container>
        </div>

        <ng-template #addMember>
            <h1>Добавить исполнителя</h1>
            <select #member
                    (change)="executorKey = member.value"
            >
                <option hidden
                        selected
                        value=""
                >
                    Выбрать исполнителя
                </option>
                <option *ngFor="let member of allMembers"
                        [class.inactive_user]="!member.is_active"
                        [value]="member.guid"
                >
                    {{ helpers.fullName(member) }}
                </option>
            </select>
        </ng-template>

        <ng-template #addDepartment>
            <h1>{{ 'MODALS.HEADERS.ADD_DEPARTMENT' | translate }}</h1>
            <select #departmentKey
                    (change)="executorKey = departmentKey.value">
                <option hidden
                        selected
                        value="">{{ 'MODALS.FIELDS.SELECT.DEPARTMENTS' | translate }}
                </option>
                <option *ngIf="!allDepartments.length"
                        disabled>{{ 'EMPTY_LISTS.EMPTY' | translate }}
                </option>
                <option *ngFor="let department of allDepartments"
                        [value]="department.department_id"
                >
                    {{ department.department_name }}
                </option>
            </select>
        </ng-template>

        <ng-template #addDivision>
            <h1>{{ 'MODALS.HEADERS.ADD_DIVISION' | translate }}</h1>
            <h2>{{ 'MODALS.FIELDS.SELECT.DEPARTMENTS' | translate }}</h2>
            <select [(ngModel)]="selectedDepartmentWithDivisions">
                <option [ngValue]="undefined"
                        hidden>{{ 'MODALS.FIELDS.SELECT.DEPARTMENTS' | translate }}
                </option>
                <option *ngIf="!allDepartments.length"
                        disabled>{{ 'EMPTY_FIELDS.EMPTY' | translate }}
                </option>
                <option *ngFor="let department of allDepartments"
                        [ngValue]="department"
                >
                    {{ department.department_name }}
                </option>
            </select>

            <div *ngIf="selectedDepartmentWithDivisions">
                <h2 class="mt-1">{{ 'MODALS.FIELDS.SELECT.DIVISION' | translate }}</h2>
                <div *ngFor="let divisionItemCont of selectedDepartmentWithDivisions.divisions"
                     class="division-item">
                    <ng-container
                            *ngTemplateOutlet="division; context: {divisionItem: divisionItemCont}"></ng-container>
                </div>
            </div>
            <ng-template #division
                         let-divisionItem="divisionItem">
                <div>
                    <div class="division-item item-head flex-display justify-content-between">
                        <div>
                            <i (click)="divisionSlider[divisionItem.id] = !divisionSlider[divisionItem.id]"
                               *ngIf="divisionItem.subdivision.length"
                               [class]="divisionSlider[divisionItem.id] ?
                                        'bi bi-caret-down mr-1 pointer' : 'bi bi-caret-right mr-1 pointer'"
                            ></i>
                            <input (change)="executorKey = divisionItem.id"
                                   class="ml-2 mr-1"
                                   name="checkDivision"
                                   style="width: unset;"
                                   type="radio">
                            <i class="bi-people mr-1"
                               ngbTooltip="{{ 'TASKS.TEXT.DIVISION' | translate }}"
                            ></i>
                            <span>{{ divisionItem.name }}</span>
                        </div>
                    </div>

                    <div *ngIf="divisionSlider[divisionItem.id]">
                        <div *ngFor="let divisionItem of divisionItem.subdivision"
                             class="subdivision">
                            <ng-container
                                    *ngTemplateOutlet="division; context: {divisionItem: divisionItem}"></ng-container>
                        </div>
                    </div>
                </div>
            </ng-template>
        </ng-template>

        <button (click)="addExecutor(modal)"
                class="btn btn-success mt-2"
                data-action="addSignerButton"
        >
            <span>{{ 'MODALS.BUTTONS.ADD' | translate }}</span>
        </button>
    </div>
</ng-template>

<ng-template #createTaskView
             let-modal>
    <app-button-modal-close (closeEmit)="createTaskDescription = null"
                            [modal]="modal"></app-button-modal-close>
    <div class="modal-body">
        <h1>{{ 'MODALS.HEADERS.TASK' | translate }}</h1>
        <h2>{{ 'MODALS.FIELDS.TITLE' | translate }}</h2>
        <input #taskName
               aria-describedby="emailHelp"
               class="form-control"
               id="taskName"
               required>

        <h2 class="mt-2">{{ 'MODALS.FIELDS.DESCRIPTION' | translate }}</h2>
        <div class="task__content mb-3">
            <app-component-ckeditor
                    (emitFinish)="createTaskDescription = $event[1]"
                    [isShowButtons]="false"
                    [isShowEditor]="false"
            ></app-component-ckeditor>
        </div>

        <h2>{{ 'MODALS.FIELDS.BUSINESS_PROCESS' | translate }}</h2>
        <select (change)="selectBoard(selectedDash)"
                [(ngModel)]="selectedDash">
            <option [ngValue]="null"
                    hidden
            >
                {{ 'MODALS.FIELDS.SELECT.BUSINESS_PROCESS' | translate }}
            </option>
            <option *ngFor="let item of dashes"
                    [ngValue]="item"
            >
                [{{ item.alias }}] {{ item.name }}
            </option>
        </select>

        <div *ngIf="changeBoard"
             class="dropdown">
            <h2>{{ 'MODALS.FIELDS.TASK_TYPE' | translate }}</h2>
            <button aria-expanded="false"
                    class="btn btn-block dropdown-toggle"
                    data-bs-toggle="dropdown"
                    type="button">
                <i [class]="selectedType.icon"></i> {{ selectedType.name ? selectedType.name : 'MODALS.SELECT.NOT_SELECTED' | translate }}
            </button>
            <ul class="dropdown-menu"
                style="overflow: auto; max-height: 350px; width: 100%">
                <li (click)="selectedType = item"
                    *ngFor="let item of changeBoard.task_types">
                    <a class="dropdown-item">
                        <i [class]="item.icon"></i> {{ item.name }}
                    </a>
                </li>
            </ul>
        </div>

        <button (click)="onCreateTask(modal, taskName.value);"
                class="btn btn-success mt-3"
                data-action="createTask"
        >
            <span>{{ 'MODALS.BUTTONS.CREATE' | translate }}</span>
        </button>
    </div>
</ng-template>

<ng-template #taskView
             let-modal>
    <app-button-modal-close [modal]="modal"
                            modalSize="xl"></app-button-modal-close>
    <div class="modal-body">
        <app-component-task-detail (emitOnDelete)="$event ? modal.close() : null"
                                   *ngIf="taskAlias"
                                   [taskAlias]="taskAlias"
        ></app-component-task-detail>
    </div>
</ng-template>
